import React, { useEffect } from 'react';
import Layout from './layout';
import { useNavigate } from 'react-router-dom';
import { URLS } from '../_config';

const Home: React.FC = () => {
    const navigate :any = useNavigate();

    useEffect(()=>{
        navigate(URLS.PROFILE);
    },[])
    return (
       <div> 

       </div>
    );
};

export default Home;